module.exports = __webpack_public_path__ + "img/bowl-icon.9f46b58e.svg";